import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import {fieldsToDataToSend} from '../../common/functions/convert'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify'
import {validateField} from '../../../actions/helpers/validation'
import {
  fetchVacancyActivateDataSuccess,
  validateVacancyActivateField,
  validateVacancyActivateWorkAmountUnitField,
  takeFirstStandardRateOnVacancyActivate,
  submitVacancyActivateFields,
  clearVacancyActivateFields,
  clearVacancyActivateField,
  clearVacancy} from '../../../actions/pages/vacancy-page'
import EditForm from '../../../pages/EditForm'
import InputField from '../../common/form/InputField'
import Textarea from '../../../pages/Textarea'
import Select from '../../common/form/Select'
import DateTimeField from '../../common/form/DateTimeField'
import Alert from '../../../ui-elements/alerts/Alert'
import '../../../css/ui-elements/modals.css'

class ActivateOrEditVacancyPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      className: 'modal-primary',
      size: 'default',
      errorMsg: null
    }

    this.toggle = this.toggle.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.openPopup = this.openPopup.bind(this)
  }

  openPopup() {
    let id = parseInt(this.props.vacancyId, 10);

    if (!Number.isInteger(id)){
      return;
    }

    this.toggle();

    let url = 'vacancies/' + id + '/edit';

    this.props.clearVacancyActivateFields();
    this.setState({
      errorMsg: null
    })

    this.props.ajax.get(url, true, (data) => {
      this.props.fetchVacancyActivateDataSuccess(data, this.descriptionRequired());
    });
  }

  descriptionRequired() {
    return this.props.profileType == "Singer" || this.props.profileType == "VoiceActor";
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    })
  }

  submitForm(event) {
    event.preventDefault();

    let validatedFields = this.props.fields.map(field => validateField(field))

    let isValid =
        validatedFields.filter(field => field.errors.length > 0).length > 0
          ? false
          : true

    this.props.submitVacancyActivateFields(validatedFields);

    if (!isValid){
      return;
    }

    let dataToSend = fieldsToDataToSend(this.props.fields);

    let vacancyStatus = this.props.vacancyOverview.Status;
    let url = 'vacancies/' + this.props.vacancyId ;

    if (vacancyStatus === 'Draft') {
      url = url + '/activate';
    }

    this.props.ajax.put(
      url,
      JSON.stringify(dataToSend),
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      },
      (response) => {
        if (response.Status === 'OK') {
          this.toggle();
          this.props.clearVacancy();
          this.props.notify(`The vacancy was ${vacancyStatus === 'Draft' ? 'activated' : 'updated'}.`);
        }
        else{
          this.setState({
            errorMsg: `Can not ${vacancyStatus === 'Draft' ? 'activate' : 'update'} vacancy (id: ${this.props.vacancyId})`
          })
        }
      })
  }

  render() {
    let vacancyStatus = this.props.vacancyOverview.Status;
    let productionStatus = this.props.vacancyOverview.ProductionStatus;

    if (productionStatus !== 'Active' || (vacancyStatus !== 'Draft' && vacancyStatus !== 'Active')) {
      return (null)
    }

    let fields = this.props.fields;

    var standardRateField = fields[3];

    var selectedRate = standardRateField.options.find((option) => {
      return option.value === standardRateField.value;
    });

    let isCustomRate = selectedRate && selectedRate.parameters.isCustomRate;

    //push customRates to end of array for better select
   const customRateExists = standardRateField.filteredOptions.some(el => el.label === 'Custom rate');
   if (customRateExists){
     let obj = standardRateField.filteredOptions.find(o => o.label === 'Custom rate');
     standardRateField.filteredOptions.push(standardRateField.filteredOptions.splice(standardRateField.filteredOptions.indexOf(obj), 1).pop());
   }

    let btnRatesListVisible = standardRateField.filteredOptions.length > 1;
    let customRateInputWidth = btnRatesListVisible ? 'calc(100% - 42px)' : '100%'

    //VisibilityType
    let visibilityType = fields[9];

    visibilityType.filteredOptions=[
      {value:"Everyone", label: "Everyone"},
      {value:"CandidatesOnly", label: "Candidates only"}
    ]

    var selectedVisibilityType = fields[9].filteredOptions.find((option) => {
      return option.value === fields[9].value;
    });
    //end VisibilityType

    return (
      <div style={{display: 'inline-block'}}>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          wrapClassName={this.state.className}
          size={this.state.size}>
          <ModalHeader toggle={this.toggle}>{vacancyStatus === 'Draft' ? 'Activate vacancy': 'Edit vacancy'}</ModalHeader>
          <ModalBody>
            <div data-background={this.props.config.background}>
              {this.state.errorMsg &&
                <Alert className="alert alert-danger alert-outline">
                  {this.state.errorMsg}
                </Alert>
              }

              <EditForm
                title=""
                description="">

                {fields[8] && this.descriptionRequired() && <InputField field={fields[8]} validate={this.props.validateVacancyActivateField} />}
                {fields[0] && <DateTimeField field={fields[0]} validate={this.props.validateVacancyActivateField} />}
                {fields[9] && <Select field={fields[9]} validate={this.props.validateVacancyActivateField} />}
                {fields[1] && <InputField field={fields[1]} validate={this.props.validateVacancyActivateField} />}
                {fields[2] && <Select field={fields[2]} validate={this.props.validateVacancyActivateWorkAmountUnitField} />}
                {!isCustomRate && <Select field={standardRateField} validate={this.props.validateVacancyActivateField} />}

                {isCustomRate &&
                  <div>
                    <div style={{display: 'inline-block', width: customRateInputWidth}}>
                      {<InputField field={fields[4]} validate={this.props.validateVacancyActivateField} />}
                    </div>
                    {btnRatesListVisible &&
                      <div style={{display: 'inline-block', cursor: 'pointer'}}>
                        <i className="material-icons material-icons-3x" style={{position: 'relative', top: '14px'}} onClick={() =>
                          this.props.takeFirstStandardRateOnVacancyActivate(standardRateField)
                        }>list</i>
                      </div>
                    }
                  </div>
                }
                <div className="row">
                  <div className="col">
                    {fields[6] && <Select field={fields[6]} validate={this.props.validateVacancyActivateField} />}
                  </div>
                  <div className="col">
                    {fields[7] && <InputField field={fields[7]} validate={this.props.validateVacancyActivateField} />}
                  </div>
                </div>
                {fields[5] && <Textarea field={fields[5]} validate={this.props.validateVacancyActivateField} rows="3" />}

              </EditForm>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-primary btn-rounded" type="submit" onClick={this.submitForm}>
            {vacancyStatus === 'Draft' ? 'Activate': 'Save'}
            </button>
            <button className="btn btn-default btn-rounded" onClick={this.toggle}>
              Close
            </button>
          </ModalFooter>
        </Modal>

        <button
          className="btn btn-primary btn-rounded mx-2"
          type="button"
          onClick={this.openPopup}>
          {vacancyStatus === 'Draft' ? 'Activate': 'Edit'}
        </button>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  vacancyOverview: state.vacancyPage.overview,
  fields: state.vacancyActivate.fields,
  config: state.config
})
const mapDispatchToProps = dispatch => ({
  fetchVacancyActivateDataSuccess: (activateData, descriptionRequired) => dispatch(fetchVacancyActivateDataSuccess(activateData, descriptionRequired)),
  submitVacancyActivateFields: fields => dispatch(submitVacancyActivateFields(fields)),
  validateVacancyActivateField: (value, field) => dispatch(validateVacancyActivateField(value, field)),
  validateVacancyActivateWorkAmountUnitField: (value, field) => {
    dispatch(validateVacancyActivateWorkAmountUnitField(value, field))
    dispatch(clearVacancyActivateField('CustomRate'))
  },
  takeFirstStandardRateOnVacancyActivate: (field) => {
    dispatch(takeFirstStandardRateOnVacancyActivate(field))
    dispatch(clearVacancyActivateField('CustomRate'))
  },
  clearVacancyActivateFields: () => dispatch(clearVacancyActivateFields()),
  clearVacancy: () => dispatch(clearVacancy())
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(ActivateOrEditVacancyPopup)
